import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { DISCORD_SERVER } from '../Layout/PageLayout';

const FooterOuter = styled.footer`
  border-top: 1px solid var(--border-subtle);
  margin-top: auto;
`;

const Inner = styled.div`
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem 2.5rem;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  color: var(--text-tertiary);
`;

const Brand = styled.span`
  font-family: var(--font-mono);
  color: var(--text-secondary);
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.75rem;

  a {
    color: var(--text-secondary);
    padding: 0.625rem 0;
    transition: color var(--transition-fast);
  }

  a:hover {
    color: var(--brand);
  }
`;

const Footer = () => (
  <FooterOuter>
    <Inner>
      <Brand>skeered · Roblox systems engineer</Brand>
      <Links aria-label="Footer">
        <Link to="/portfolio">Work</Link>
        <Link to="/prices">Services</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
        <a href={DISCORD_SERVER} target="_blank" rel="noopener noreferrer">Discord</a>
      </Links>
      <span>© {new Date().getFullYear()} Skeered</span>
    </Inner>
  </FooterOuter>
);

export default Footer;
